import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {LabelXSmall} from "@khanacademy/wonder-blocks-typography";
import {staticUrl} from "@khan/urls";

export default function InternationalContentLinks(): React.ReactElement {
    return (
        <View style={styles.intlContainer}>
            <LabelXSmall>{t`Country`}</LabelXSmall>
            {[
                {
                    name: t`U.S.`,
                    flagImage: "/images/country-flag-icons/us-flag.png",
                    link: "https://www.khanacademy.org",
                },
                {
                    name: t`India`,
                    flagImage: "/images/country-flag-icons/india-flag.png",
                    link: "https://india.khanacademy.org",
                },
                {
                    name: t`Mexico`,
                    flagImage: "/images/country-flag-icons/mexico-flag.png",
                    link: "https://es.khanacademy.org",
                },
                {
                    name: t`Brazil`,
                    flagImage: "/images/country-flag-icons/brazil-flag.png",
                    link: "https://pt.khanacademy.org",
                },
            ].map((country, i) => (
                <a
                    key={country.name}
                    className={css(styles.link)}
                    href={country.link}
                >
                    <img
                        className={css(styles.flagIcons)}
                        src={staticUrl(country.flagImage)}
                        alt=""
                    />
                    {country.name}
                </a>
            ))}
        </View>
    );
}

const styles = StyleSheet.create({
    intlContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "279px",
    },
    link: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        height: "13px",
        color: "#fff",
        textDecoration: "none",
        fontSize: "12px",
        marginLeft: "12px",
        ":hover": {
            textDecoration: "underline",
        },
    },
    flagIcons: {
        width: "13px",
        height: "12px",
        margin: "1px 6px 0 0",
    },
});
